/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs */

const en__field_enum_icsrm_weiterbildungsmoeglichkeiten33 = /** @type {(inputs: _Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tips to find opertunities for more specialiced education`)
};

const de__field_enum_icsrm_weiterbildungsmoeglichkeiten33 = /** @type {(inputs: _Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps zu Weiterbildungsmöglichkeiten`)
};

/**
* | output |
* | --- |
* | "tips to find opertunities for more specialiced education" |
*
* @param {_Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_weiterbildungsmoeglichkeiten33 = /** @type {((inputs?: _Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Weiterbildungsmoeglichkeiten33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_weiterbildungsmoeglichkeiten33(inputs)
	return de__field_enum_icsrm_weiterbildungsmoeglichkeiten33(inputs)
});
export { _field_enum_icsrm_weiterbildungsmoeglichkeiten33 as "_field_enum_ICSRM_WEITERBILDUNGSMOEGLICHKEITEN" }